// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"71e08e9f","113":"a959eb82","127":"9a6b15e8","136":"3e12f142","151":"4a4226fb","181":"030b1caf","198":"609e67b8","481":"70d8ee0b","488":"f1dc7667","700":"e2ec0afe","721":"de2b089a","746":"188f30b9","941":"47553c77","990":"90831e63"}[chunkId] + ".chunk.js";
};